import { chooseMember } from '@/api/member';
import {
  setMemberId,
  getMemberId,
  setBranchId,
  getBranchId
} from '@/store/utils/member';
import store from '@/store';
import {
  setOrder,
  setPrograms,
  setProducts,
  setIndex
} from '@/store/utils/order';

let memberId = getMemberId();

let branchId = getBranchId();

const state = {
  memberId,
  branchId
};

const actions = {
  chooseMember({ commit }, { type, phone, tax_id, cb, branch_id }) {
    chooseMember({ type, phone, tax_id, branch_id }, member => {
      if (member == null) {
        alert('無查詢結果');
      } else {
        commit('setMemberId', member.member_id);
        commit('setBranchId', branch_id);
        if (cb) {
          cb(member);
        }
      }
    });
  },
  reselectMember({ commit }) {
    commit('setMemberId', {});
    commit('setBranchId', {});
    commit('setOrder', {});
    commit('setIndex', 1);
    commit('setProducts', []);
    commit('setPrograms', []);
  }
};

const mutations = {
  setMemberId(state, memberId) {
    if (state.memberId != memberId) {
      store.dispatch('order/clearOrder');
    }
    state.memberId = memberId;

    setMemberId(memberId);
  },
  setOrder(state, order) {
    state.order = order;

    setOrder(order);
  },
  setIndex(state, index) {
    state.index = index;

    setIndex(index);
  },
  setProducts(state, products) {
    state.products = products;

    setProducts(products);
  },
  setPrograms(state, programs) {
    state.programs = programs;

    setPrograms(programs);
  },
  setBranchId(state, branchId) {
    state.branchId = branchId;

    setBranchId(branchId);
  }
};

const getters = {
  isChoose(state) {
    return state.memberId ? true : false;
  },
  memberId(state) {
    return state.memberId;
  },
  branchId(state) {
    return state.branchId;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
